import { defineEffect } from '../../../core/effect';
import { spec } from '../fx/damage';

/** 状況 `damage_battle`（組み立ては `../fx/damage.js`。arcade はどの状況も同じ絵） */
export default defineEffect({ situation: 'damage_battle', role: 'effect', ...spec }, 'damage_battle_effect.js');
